import React from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CardActionArea from "@mui/material/CardActionArea";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { Rail, SectionHeader, DISCOVERY_CARD_SX } from "/imports/ui/components/discovery";
import { LocationBanner } from "../../LocationsView";

// Mobile lists only the first few; the rest are one tap away under "View all".
const MOBILE_LIMIT = 3;

function LocationsRail({ locations, go }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const viewAll = () => go("locations");

  if (isMobile) {
    return (
      <Box sx={{ mb: 4 }}>
        <SectionHeader title="Locations" onViewAll={viewAll} />
        <Box sx={{ ...DISCOVERY_CARD_SX, overflow: "hidden" }}>
          {locations.slice(0, MOBILE_LIMIT).map((loc, index) => (
            <CardActionArea
              key={loc._id}
              onClick={() => go(`locations/${loc._id}`)}
              sx={{
                p: 1.5,
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                borderTop: index === 0 ? 0 : "1px solid",
                borderColor: "divider"
              }}
            >
              <Box sx={{ width: "3.5rem", height: "3.5rem", borderRadius: 2, overflow: "hidden", flexShrink: 0 }}>
                <LocationBanner height={56} src={loc.imgUrls?.[0]} />
              </Box>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography fontWeight={600} noWrap>
                  {loc.name}
                </Typography>
                {loc.location && (
                  <Typography variant="caption" color="text.secondary" noWrap sx={{ display: "block" }}>
                    {loc.location}
                  </Typography>
                )}
              </Box>
              <ChevronRightIcon sx={{ color: "text.disabled", flexShrink: 0 }} />
            </CardActionArea>
          ))}
        </Box>
      </Box>
    );
  }

  return (
    <Rail title="Locations" onViewAll={viewAll}>
      {locations.map((loc) => (
        <Box key={loc._id} sx={{ ...DISCOVERY_CARD_SX, width: "11.25rem", flexShrink: 0, overflow: "hidden" }}>
          <CardActionArea onClick={() => go(`locations/${loc._id}`)} sx={{ height: "100%" }}>
            <LocationBanner height={76} src={loc.imgUrls?.[0]} />
            <Box sx={{ p: 1.5 }}>
              <Typography fontWeight={600} noWrap>
                {loc.name}
              </Typography>
              {loc.location && (
                <Typography variant="caption" color="text.secondary" noWrap sx={{ display: "block" }}>
                  {loc.location}
                </Typography>
              )}
            </Box>
          </CardActionArea>
        </Box>
      ))}
    </Rail>
  );
}

export default LocationsRail;
